





































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TournamentProgressItem from './TournamentProgressItem.vue'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import matchStore from '@/modules/match/match.store'
import userStore from '@/modules/auth/auth.store'
import { TournamentTeamRole, TournamentTeamState } from '@/api/tournamentTeam'
import { TournamentEntity, TournamentState } from '@/api/tournament'
import moment from 'moment'

@Component({
  components: { TournamentProgressItem }
})
export default class TournamentProgress extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)
  matchModule = getModule(matchStore, this.$store)

  snackbar: boolean = true
  loaded: boolean = false

  @Watch('tournament')
  onTournamentChanged(newVal: TournamentEntity, oldVal: TournamentEntity) {
    this.snackbar = true

    if (!newVal && oldVal) {
      this.loaded = false
    }
  }

  @Watch('loading')
  onLoadingChanged(newVal: boolean, oldVal: boolean) {
    if (!newVal && oldVal) {
      this.loaded = true
    }
  }

  get memberId() {
    return this.userModule.memberId
  }

  get loading() {
    return (
      !this.tournament ||
      (!this.tournamentTeam &&
        this.tournamentModule.joinedTournamentTeamLoading)
    )
  }

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get tournamentTeam() {
    return this.tournamentModule.selectedTournamentTeam
  }

  get isJoined() {
    if (!this.tournamentTeam) {
      return false
    }

    const player = this.tournamentTeam.players.find(
      player => player.memberId === this.memberId
    )

    if (!player) {
      return false
    }

    return player.role !== TournamentTeamRole.RequestToJoin
  }

  get isCaptain() {
    if (!this.tournamentTeam) {
      return false
    }

    const player = this.tournamentTeam.players.find(
      player => player.memberId === this.memberId
    )

    if (!player) {
      return false
    }

    return player.role === TournamentTeamRole.Captain
  }

  get isConfirmedRoster() {
    return (
      this.tournamentTeam &&
      this.tournamentTeam.state === TournamentTeamState.Registered
    )
  }

  get step() {
    if (
      !this.tournament ||
      this.tournament.state === TournamentState.Cancelled
    ) {
      return 0
    }

    if (this.tournament.state === TournamentState.Completed) {
      return this.isJoined ? 5 : 0
    }

    if (
      !this.isJoined &&
      this.tournament.state === TournamentState.OpenRegistration
    ) {
      return 1
    }

    if (this.isJoined) {
      if (
        this.tournament.state === TournamentState.OpenRegistration &&
        !this.isConfirmedRoster
      ) {
        return 2
      }

      if (this.tournament.state === TournamentState.InProgress) {
        return this.tournament.isTournamentCheckInEnable ? 4 : 3
      }

      if (
        this.isConfirmedRoster ||
        this.tournament.state === TournamentState.WaitingForCheckIn
      ) {
        return 3
      }
    }

    return 0
  }

  get progress() {
    if (
      !this.tournament ||
      this.tournament.state === TournamentState.Cancelled
    ) {
      return 0
    }

    if (this.tournament.state === TournamentState.Completed) {
      return this.isJoined ? 100 : 0
    }

    if (
      !this.isJoined &&
      this.tournament.state === TournamentState.OpenRegistration
    ) {
      return 0
    }

    if (this.isJoined) {
      if (
        this.tournament.state === TournamentState.OpenRegistration &&
        !this.isConfirmedRoster
      ) {
        return 25
      }

      if (this.tournament.state === TournamentState.InProgress) {
        return this.tournamentTeam && this.tournamentTeam.isOut ? 100 : 75
      }

      if (this.isConfirmedRoster) {
        return 50
      }

      if (this.tournament.state === TournamentState.WaitingForCheckIn) {
        return 62
      }
    }

    return 0
  }

  get TournamentState() {
    return TournamentState
  }

  get shouldSnackbarVisible() {
    return !this.loading && this.snackbar && [2, 3, 4].includes(this.step)
  }

  get tournamentCheckInDuration() {
    if (!this.tournament || !this.tournament.isTournamentCheckInEnable) {
      return 0
    }

    return this.tournament.tournamentCheckInDuration
  }

  get tournamentCheckInEndTime() {
    if (!this.tournament || !this.tournament.isTournamentCheckInEnable) {
      return '00:00'
    }

    return moment
      .unix(this.tournament.tournamentCheckInDuration!)
      .format('HH:mm')
  }

  get isMatchRoomAvailable() {
    if (!this.tournament || !this.matchModule.joinableMatchRooms) {
      return false
    }

    return this.matchModule.joinableMatchRooms!.find(
      mr =>
        mr.relatedTournament &&
        mr.relatedTournament.tournamentId === this.tournament!.tournamentId
    )
  }

  get isTournamentCheckedIn() {
    if (!this.tournament || !this.tournamentTeam) {
      return false
    }

    return this.tournamentTeam.isTournamentCheckedIn
  }
}
